import { AxiosResponse } from 'axios';
import { Dispatch, SetStateAction } from 'react';

import { AxiosRequest } from '@asa/asasqt-microfrontend-components/dist/common/api/axios';
import {
  ComboxWebConfig,
  DmsCommand,
  UserSettings,
} from '@asa/asasqt-microfrontend-components/dist/common/types';
import {
  ConnectionTypeValues,
  PriceSettingsValues,
} from '@asa/asasqt-microfrontend-components/dist/common/types/shared/auth';

import { StockAvailabilityResponse } from '@/core/common/api/serviceHub';

export type ActionButtonContainerProps = {
  handleSave: () => void;
  handleCancel: () => void;
  handleEdit: () => void;
  isReadonly: boolean;
  dataTestId?: string;
};

export type HeaderSectionMoleculeProps = ActionButtonContainerProps & {};

export type BottomSectionMoleculeProps = ActionButtonContainerProps & {};

export type UserData = {
  language: string;
  username: string;
};

export type UserSettingsForm = Omit<
  UserSettings,
  'id' | 'defaultLanguage' | 'version'
>;

export type DmsConnectionForm = Omit<
  UserSettingsForm,
  'prices' | 'connectionType'
> & {
  prices?: PriceSettingsValues;
  connectionType?: ConnectionTypeValues;
  connectionStatus?: DmsConnectionStatus;
};

export interface StockAvailabilityForm {
  customerNumber?: string;
  partNumber?: string;
  requestedUnits?: number;
  connectionStatus?: DmsConnectionStatus;
}

export type EditableUserSettingsOrganismProps = {
  userData: UserData;
  setUserData: Dispatch<SetStateAction<UserData>>;
  isChanged?: () => void;
};

export type ReadonlyUserSettingsOrganismProps = {
  userData: UserData;
  userSettingsApiData?: UserSettings;
  connectionStatus?: DmsConnectionStatus;
};

export enum DmsConnectionStatus {
  NotConnected = 'NotConnected',
  Loading = 'Loading',
  Connected = 'Connected',
  Failed = 'Failed',
}

export type DmsConnectionStatusAtomProps = {
  status?: DmsConnectionStatus;
  onClick?: () => void;
  isVerifyPart?: boolean;
  connectionTimeStamp?: string;
  debugInfo?: string;
  isDisabled?: boolean;
};

export type DmsTestingStockAtomProps = {
  stockAvailability: StockAvailabilityResponse;
  onClickVerifyPart?: () => void;
};

export type CommandsAvailableResponse = AxiosResponse & {
  commands: DmsCommand[];
  requestToken: string | null;
  statusCode: number;
};

export type ComboxWebConfigRequest = AxiosRequest & {
  accountLogin: string;
};

export type DmsConfig = {
  dmsId: string;
  service: ComboxWebConfig;
};

export type ComboxWebConfigResponse = AxiosResponse & {
  dmsConfigs: DmsConfig[];
};
